import { Link } from "react-router-dom";

/**
 * Benefit-ordered coach todo list shared by seeker and recruiter dashboards.
 */
export default function CoachTodoList({ todos = [], evaluating = false, generatedUtc = null, title = "Your next best moves" }) {
  const items = Array.isArray(todos) ? todos : [];

  return (
    <div className="tabsection coach-todo-list">
      <div className="listTitle">
        <span>{title}</span>
        {evaluating ? <span className="coach-todo-list__status">Recalculating…</span> : null}
      </div>
      {generatedUtc ? (
        <p className="byline coach-todo-list__asof">
          As of {new Date(generatedUtc).toLocaleString()}
        </p>
      ) : null}
      {items.length === 0 ? (
        <p className="byline">
          {evaluating
            ? "We’re refreshing coaching based on your latest profile…"
            : "You’re in good shape — check back after you update skills or preferences."}
        </p>
      ) : (
        <ol className="coach-todo-list__items">
          {items.map((t) => {
            const key = t.Key || t.key;
            const benefit = t.BenefitSummary || t.benefitSummary;
            const todoTitle = t.Title || t.title;
            const label = t.ActionLabel || t.actionLabel || "Take action";
            const route = t.ActionRoute || t.actionRoute;
            const kind = t.Kind || t.kind || "Action";
            return (
              <li key={key} className={`coach-todo-list__item kind-${String(kind).toLowerCase()}`}>
                {benefit ? <div className="coach-todo-list__benefit">{benefit}</div> : null}
                <div className="coach-todo-list__ask">{todoTitle}</div>
                {route ? (
                  <Link className="coach-todo-list__cta" to={route}>
                    {label}
                  </Link>
                ) : null}
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
